import { TableRow } from '@tiptap/extension-table'

export type { TableRowOptions } from '@tiptap/extension-table'
export { TableRow } from '@tiptap/extension-table'

export default TableRow
